import { render } from "./SaveTableViewDialog.vue?vue&type=template&id=c13b6638"
import script from "./SaveTableViewDialog.vue?vue&type=script&lang=js"
export * from "./SaveTableViewDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__